import { createContext, useContext } from 'react'
import type { ShaderCodeModelHost } from './types'

/**
 * The host's shader-writing capability, if it offers one. The desktop app
 * provides it around the node editor; the hosted web app does not, and shader
 * generation then goes straight to the provider the user picked.
 */
export const ShaderCodeModelHostContext = createContext<ShaderCodeModelHost | null>(null)

export function useShaderCodeModelHost(): ShaderCodeModelHost | null {
  return useContext(ShaderCodeModelHostContext)
}
